import MultiSelectFieldAttribute from '/app/javascript/bundles/KeenformRenderer/components/formelements/MultiSelectFieldAttribute/MultiSelectFieldAttribute';

export default class MultiSelectFieldEditor extends MultiSelectFieldAttribute{

  getPropsForCheckboxInput (option, index) {
    let checkboxInputProps = super.getPropsForCheckboxInput(option, index);
    return {
      ...checkboxInputProps,
      checked: undefined,
      defaultChecked: false,
      onChange: ()=>{ console.log('checkbox was clicked in editor')}
    }
  }

  getValue() {
    return undefined;
  }

  isThisOptionInValue(option) {
    return false;
  }

  toggleOption() {
    console.log('do nothing for editor');
  }

  optionContainerClicked(event, option) {
    console.log('do nothing');
  }
}
